<h1 class="text-center">{{ "loginPage.title" | translate }}</h1>
<div class="main-container">
  <app-login-form [showBorder]="true" (loginFormSubmit)="loginFormSubmit($event)"></app-login-form>
</div>
